import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;
interface PaymentCardProps {
  selected: boolean;
  hidden?: boolean;
}

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e8e8e8;
  margin: 16px 0;
`;

export const CardInfo = styled.div`
  color: var(--purple);
  .limit-header {
    margin-top: 5px;
    color: var(--orange);
    font-weight: bold;
  }
`;

export const WarningText = styled.p`
  margin-top: 12px;
  font-size: 15px;
  color: #d36a2e;
  line-height: 1.4;
`;
